// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"d17b1b83","360":"e0ecb6c7","417":"31343ad7","651":"d18e4307","702":"903c6ee1","955":"06a35a4d","981":"61934f77"}[chunkId] + ".chunk.js";
};